<template>
  <a-drawer
    :visible="visible"
    :width="640"
    title="用户优惠券 · 已使用统计"
    @close="close"
    destroy-on-close
    wrap-class-name="stat-drawer"
  >
    <!-- 数字卡片 -->
    <a-row :gutter="16" class="card-row">
      <a-col :span="12">
        <div class="stat-card">
          <div class="label">已使用数量</div>
          <div class="value">{{ stat.useNum }}</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="stat-card">
          <div class="label">优惠总金额</div>
          <div class="value money">¥{{ stat.money.toFixed(2) }}</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="stat-card">
          <div class="label">优惠券总量</div>
          <div class="value">{{ stat.allNum }}</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="stat-card">
          <div class="label">失效数量</div>
          <div class="value">{{ stat.noNum }}</div>
        </div>
      </a-col>
    </a-row>

    <div class="footer">
      <a-button type="primary" block @click="close">知道了</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { infoStatUserCoupon } from '@/api/coupon/controller/index.js'

export default {
  name: 'UserCouponUsedStatDrawer',

  props: {

  },
  data() {
    return {
      visible: false,
      stat: {
        allNum: 0,
        money: 0,
        noNum: 0,
        noUseNum: 0,
        useNum: 0,
      },
      couponId: '',
    }
  },
  computed: {
    pieOption() {
      const { useNum, noUseNum, noNum } = this.stat
      return {
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        legend: { bottom: 0 },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: { show: true, formatter: '{b}\n{d}%' },
            data: [
              { name: '已使用', value: useNum, itemStyle: { color: '#52c41a' } },
              { name: '未使用', value: noUseNum, itemStyle: { color: '#1890ff' } },
              { name: '已失效', value: noNum, itemStyle: { color: '#ff4d4f' } },
            ],
          },
        ],
      }
    },
  },
  methods: {
    open(e) {
      this.visible = true
      this.couponId = e.id
      this.loadStat()
    },
    close() {
      this.visible = false
    },
    async loadStat() {
      const res = await infoStatUserCoupon({
        pageNum: 1,
        pageSize: 9999,
        couponId: this.couponId,
      })
      this.stat = res.data
    },
  },
}
</script>

<style scoped lang="less">
.stat-drawer .ant-drawer-body {
  padding: 24px;
}
.card-row {
  margin-bottom: 24px;
}
.stat-card {
  background: #f6f7f9;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  .label {
    font-size: 14px;
    color: #8c8c8c;
    margin-bottom: 8px;
  }
  .value {
    font-size: 28px;
    font-weight: 600;
    color: #262626;
    &.money {
      color: #fa541c;
    }
  }
}
.chart-box {
  height: 260px;
  margin-bottom: 24px;
}
.footer {
  border-top: 1px solid #f0f0f0;
  padding-top: 16px;
}
</style>
